import React, { useCallback, useEffect, useState } from 'react'

import useFirebase from 'hooks/firebase'

import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  LinearProgress,
  Link,
  Typography,
} from '@mui/material'

import { useDropzone } from 'react-dropzone'

import Papa from 'papaparse'

const BulkStudents = (props) => {
  const { director } = props

  const { functions } = useFirebase()
  const { createUser } = functions
  
  const [file, setFile] = useState()
  const onDropAccepted = useCallback(acceptedFiles => {
    if (acceptedFiles.length > 0) {
      setFile(acceptedFiles[0])
    }
  }, [])

  const {
    // acceptedFiles,
    getRootProps,
    getInputProps,
    // isDragActive,
    // isDragAccept,
    // isDragReject
  } = useDropzone({
    accept: { 'text/csv': ['.csv'] },
    maxFiles: 1,
    onDropAccepted
  })

  const [parsed, setParsed] = useState()

  const handleParse = () => {
    Papa.parse(file, {
      complete: (results) => {
        setParsed(results.data)
      }
    })
  }

  useEffect(() => {
    if (file === undefined) return
    handleParse()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file])

  const [progress, setProgress] = useState(0)
  const [count, setCount] = useState(0)

  const onLoad = async () => {
    for (let i = 1; i < parsed.length; i++) {
      setCount(i)
      setProgress(i * 100 / (parsed.length - 1))
      const data = {
        'role': 'student',
        'schoolId': director.schoolId,
        'user': {
          'firstName': parsed[i][0],
          'fathersLastName': parsed[i][1],
          'mothersLastName': parsed[i][2],
          'name': `${parsed[i][0]} ${parsed[i][1]}`,
          'email': parsed[i][3],
          'level': parsed[i][4],
          'grade': parsed[i][5],
          'group': parsed[i][6]
        },
      }
      await createUser(data)
    }
    clean()
  }

  const clean = () => {
    setCount(0)
    setFile(undefined)
    setParsed(undefined)
    setProgress(0)
  }

  return (
    <Card sx={{ borderColor: '#655dc633', borderRadius: 2, p: 2 }}>
      <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography color='primary' variant='body1' gutterBottom>
              <b style={{ fontWeight: 900 }}>CARGAR ALUMNOS</b>
            </Typography>
            <Typography variant='body1'>
              Para crear diferentes cuentas a la vez puedes utilizar <Link href='https://firebasestorage.googleapis.com/v0/b/lightspot-app.appspot.com/o/templates%2Falumnos.csv?alt=media&token=a32e5f4a-1e6c-475a-a81d-8486b5d3ed97'>nuestra plantilla</Link> y llenar los datos de tus alumnos.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Box
              sx={{
                alignItems: 'center',
                backgroundColor: '#373f470a',
                borderColor: '#373f471a',
                borderRadius: '2px',
                borderStyle: 'dashed',
                borderWidth: '2px',
                color: '#373f4799',
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                mt: 1,
                outline: 'none',
                p: 2,
                transition: 'border .24s ease-in-out'
              }}
              {...getRootProps({})}
            >
                <input {...getInputProps()} />
                {
                  <Typography variant='body1' align='center'>
                    Arrastra tu archivo o haz clic aquí
                  </Typography>
                }
            </Box>
          </Grid>
          {
            parsed !== undefined ? (
              <Grid item xs={12}>
                <Typography variant='body1'>
                  Se encontró registro de {parsed.length - 1} alumnos
                </Typography>
              </Grid>
            ) : null
          }
          {
            parsed !== undefined ? (
              <Grid item xs={12}>
                <LinearProgress sx={{ mb: 1 }} variant='determinate' value={progress} />
                <Typography variant='caption'>
                  Procesando {count} alumnos de {parsed.length - 1}
                </Typography>
              </Grid>
            ) : null
          }
          <Grid item xs={12} align='right'>
            <Button disabled={parsed === undefined || count !== 0} disableElevation variant='contained' onClick={onLoad}>
              <b style={{ fontWeight: 900 }}>CARGAR</b>
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default BulkStudents